import axios from "axios";
import { API_BASE_URL } from "./header";
import { toast } from "sonner";
import { all_routes } from "../Router/all_routes";
import store from "../core/redux/store";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 15 seconds
});

// Request interceptor to add the bearer token and tenant header
apiClient.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.bearer_token;
    const hostname = window.location.hostname;
    let tenant = "test";

    if (
      hostname !== "localhost" &&
      hostname !== "127.0.0.1" &&
      !hostname.includes("front")
    ) {
      const parts = hostname.split(".");
      if (parts.length > 2) {
        if (parts[0].toLowerCase() === "www") {
          tenant = parts.length > 3 ? parts[1] : "test";
        } else {
          tenant = parts[0];
        }
      }
    }

    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Use tenant from subdomain, or fallback to user data, or 'test'
    if (!config.headers["X-Tenant"]) {
      config.headers["X-Tenant"] =
        tenant || state.user_data?.tenant_id || "test";
    }

    // Only set application/json if not sending FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    if (state.current_store?.id && config.headers["X-Store-Id"] === undefined) {
      config.headers["X-Store-Id"] = state.current_store.id;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for handling errors globally
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Session timeout (401 Unauthorized)
    if (error.response && error.response.status === 401) {
      // Avoid infinite loop if login/signin fails with 401
      if (
        originalRequest.url.includes("/login") ||
        originalRequest.url.includes("/signin")
      ) {
        return Promise.reject(error);
      }

      // Clear all auth state from redux
      store.dispatch({ type: "Bearer_token", payload: null });
      store.dispatch({ type: "User_data", payload: null });
      store.dispatch({ type: "Current_Store", payload: null });
      store.dispatch({ type: "Userpermission_data", payload: [] });
      store.dispatch({ type: "Rolesandpermission_data", payload: null });
      store.dispatch({ type: "Current_Cart", payload: [] });

      // Clear persisted storage so stale auth data is not rehydrated on next load
      localStorage.clear();
      sessionStorage.clear();

      toast.error("Session Expired", {
        description: "Your session has timed out. Please log in again.",
      });

      window.location.href = all_routes.signin || "/signin";
      return Promise.reject(error);
    }

    // Generic error handling can also be added here
    return Promise.reject(error);
  },
);

export default apiClient;
